import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { IImportUserDetailsFailedUserInterface } from 'app/projects/user/src/lib/interfaces/import-user-details-failed-user.interface';
import { ILanguageService } from 'app/projects/shared/src/lib/interfaces/language.interface';
import { MAXBRAIN_LANGUAGE_SERVICE } from 'app/projects/shared/src/lib/services/language.token';
import { FetchUsersReportDetailsSuccess } from 'app/projects/user/src/lib/actions/fetch-users-report-details-success.action';
import { FetchUsersReportDetails } from 'app/projects/user/src/lib/actions/fetch-users-report-details.action';
import { IImportUserDetailsModulesInterface } from 'app/projects/user/src/lib/interfaces/import-user-details-modules.interface';
import { User } from 'app/projects/user/src/lib/models/user';
import { take, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-import-user-details-dialog',
    templateUrl: './import-user-details-dialog.component.html',
    styleUrls: ['./import-user-details-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ImportUsersDetailsDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    title: string;

    @Input()
    jobId: string;

    isLoading: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<ImportUsersDetailsDialogComponent>,
        @Inject(MAXBRAIN_LANGUAGE_SERVICE) public languageService: ILanguageService,
        private _store: Store,
        private _action$: Actions
    ) {
        super();
    }

    dataSourceCreatedUsers: User[];
    dataSourceDuplicatedUsers: User[];
    dataSourceFailedUsers: IImportUserDetailsFailedUserInterface[];
    dataSourceModules: IImportUserDetailsModulesInterface[];
    displayedColumns: string[] = ['email', 'firstName', 'lastName', 'language'];
    displayedFailedColumns: string[] = ['email', 'firstName', 'lastName', 'language', 'error'];
    displayedModuleColumns: string[] = ['moduleName', 'newlyAssigned', 'alreadyAssigned', 'assignmentFailed'];
    nbrUsersCreated = 0;
    nbrUsersDuplicated = 0;
    nbrUsersFailed = 0;
    nbrModules = 0;

    ngOnInit(): void {
        this._store.dispatch(new FetchUsersReportDetails(this.jobId));

        this._action$.pipe(takeUntil(this._unsubscribeAll), ofActionDispatched(FetchUsersReportDetailsSuccess), take(1)).subscribe((action: FetchUsersReportDetailsSuccess) => {
            if (action.payload) {
                this.dataSourceCreatedUsers = action.payload.getUsersCreated();
                this.dataSourceDuplicatedUsers = action.payload.getUsersDuplicated();
                this.dataSourceFailedUsers = action.payload.getUsersFailed();
                this.dataSourceModules = action.payload.getModules();
                this.nbrUsersCreated = this.dataSourceCreatedUsers.length;
                this.nbrUsersDuplicated = this.dataSourceDuplicatedUsers.length;
                this.nbrUsersFailed = this.dataSourceFailedUsers.length;
                this.nbrModules = this.dataSourceModules.length;
            }
            this.isLoading = false;
        });
    }
}
